import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f26e5888&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=f26e5888&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26e5888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f26e5888')) {
      api.createRecord('f26e5888', component.options)
    } else {
      api.reload('f26e5888', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=f26e5888&scoped=true", function () {
      api.rerender('f26e5888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/news/detail.vue"
export default component.exports